export default "__VITE_ASSET__BOhXp_76__"